import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { useNavigate } from 'react-router-dom';

import { Icon } from '@/ui';

import type { BottomNavigationActionProps } from '@mui/material/BottomNavigationAction';
import type { FC } from 'react';

interface BottomBarButtonProps extends Omit<
  BottomNavigationActionProps,
  'icon' | 'label' | 'value'
> {
  activeRoutes?: string[];
  icon: string;
  label: string;
  route: string;
}

const BottomBarButton: FC<BottomBarButtonProps> = ({
  activeRoutes: _activeRoutes,
  icon: pendingIcon,
  route,
  label,
  ...actionProps
}) => {
  const navigation = useNavigate();

  const onClick = () => navigation(route);

  return (
    <BottomNavigationAction
      {...actionProps}
      icon={<Icon>{pendingIcon}</Icon>}
      label={label}
      value={route}
      onClick={onClick}
    />
  );
};

export default BottomBarButton;
